import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import tenantPickerMixin from '../core/tenant/pickerMixin';
import ApiService from '../../services/apiService';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import { get } from 'lodash';
export default {
  name: 'CoreDialogEula',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  mixins: [tenantPickerMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      termsAndConditions: '',
      title: ''
    };
  },
  computed: _objectSpread({}, mapState('app', ['color'])),
  watch: {
    userId: function userId() {
      var _this = this;

      if (!this.userId) {
        return;
      }

      ApiService.getUser(this, this.userId).then(function (user) {
        ApiService.getTermsAndConditions(user.access[0].tenantId).then(function (result) {
          _this.termsAndConditions = get(result, "termsAndConditions[0].termsAndConditions[".concat(localStorage.getItem('language') || 'de', "]"));
          _this.title = get(result, "termsAndConditions[0].termsAndConditions.title[".concat(localStorage.getItem('language') || 'de', "]"));
        }).catch(function (error) {
          console.error(error);
        });
      }).catch(function (error) {
        console.error(error);
      });
    }
  },
  methods: {
    handleAccept: function handleAccept() {
      var _this2 = this;

      ApiService.userAcceptEula().then(function () {
        _this2.$store.dispatch('authentication/verify').catch(function () {
          _this2.$snack('Error while accepting the agreement', 'error');
        });
      }).catch(function () {
        _this2.$snack('Error while accepting the agreement', 'error');

        _this2.handleDecline();
      });
    },
    handleDecline: function handleDecline() {
      var _this3 = this;

      this.$store.dispatch('authentication/logout').then(function () {
        _this3.$router.push('/login');
      }).catch(function () {// empty
      });
    }
  }
};